import { on, closest, findAllIn, removeClass, addClass, findIn, trigger } from "@elements/dom-utils";
import { onFind, cleanUpInScope } from "@elements/init-modules-in-scope";
import { validateForm, isValid } from "./form-validation";
import * as formValidation from './form-validation';

export function init () {

    onFind('.js-display-dependent', function(baseElement){
       let inputFields = findAllIn('.js-display-dependent__field', baseElement);
       let area = findIn('.js-display-dependent__area', baseElement);

        inputFields.forEach(item => {
            on('change', (evt) => changeHandler(evt, evt.target, baseElement), item);

            let dataIsShipping = item.getAttribute('data-is-shipping');

            if(dataIsShipping){
                _config.isShippingOpen = false;
            }
        });

        let formElementsInputs = findAllIn('.js-display-dependent__area-input', area);

        formElementsInputs.forEach(item => {
            item.required = false;
            removeCustomValidation(item);
        });
    });

}

function changeHandler(evt, item, baseElement) {
    let closestDependent = closest('.js-display-dependent', item);
    let closestArea = findIn('.js-display-dependent__area', closestDependent);

    addClass('d-none', closestArea);

    let formElementsInputs = findAllIn('.js-display-dependent__area-input', closestArea);

    formElementsInputs.forEach(item => {
        item.required = false;
        removeCustomValidation(item);
    });


    let dataToggleTarget = item.getAttribute('data-display-dependent-toggle-area');
    let dataIsShipping = item.getAttribute('data-is-shipping');

    _config.isShippingOpen = false;



    if(dataToggleTarget){
        removeClass('d-none', closestArea);

        if(dataIsShipping){
            _config.isShippingOpen = true;
        }

        let formElementsInputs = findAllIn('.js-display-dependent__area-input', closestArea);

        formElementsInputs.forEach(item => {
            let formGroup = closest('.form-group', item);
            let requiredLabel = findIn('.js-form-input-required', formGroup);
            let setRequiredInput = item.getAttribute('data-set-required-input');

            if(item.getAttribute('data-required') !== null){
                if(item.getAttribute('data-required').toString() === 'false'){
                    if (setRequiredInput ){
                        if (!setRequiredInput === 'true'){
                            item.required = false;
                            if (requiredLabel){
                                requiredLabel.hidden = true;
                            }
                            removeCustomValidation(item);
                        }
                    }else{
                        item.required = false;
                        if (requiredLabel){
                            requiredLabel.hidden = true;
                        }
                        removeCustomValidation(item);
                    }

                }
            } else {
                if (setRequiredInput){
                    if (setRequiredInput === 'true'){
                        item.required = true;
                        if (requiredLabel){
                            requiredLabel.hidden = false;
                        }
                        addCustomValidation(item);
                    }
                }else{
                    item.required = true;
                    if (requiredLabel){
                        requiredLabel.hidden = false;
                    }
                    addCustomValidation(item);
                }

            }
        })

    }


    window.dispatchEvent(new Event('resize'));

    cleanUpInScope(closest('form', evt.target))
    formValidation.init();

    trigger('display-dependent-changed', baseElement);
}

function removeCustomValidation(item) {
    let customValidation = item.getAttribute('data-custom-validation');
    if (customValidation) {
        item.removeAttribute(customValidation.split(':')[0]);
    }
}

function addCustomValidation(item) {
    let customValidation = item.getAttribute('data-custom-validation');
    if (customValidation) {
        item.setAttribute(customValidation.split(':')[0], customValidation.split(':')[1]);
    }
}